import React, { useState, useEffect, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import ComFunction from "../components/ComFunction";
import { useSelector } from "react-redux";
import { isEmpty } from '../modules/appLibrary';

//---------------------------------------------------------------------
//  付箋マーク検索リスト
//---------------------------------------------------------------------
export default function StickyList(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);

    const open = useSelector(state => state.search.stickyopen);
    const datainfo = useSelector(state => state.search.data);
    const rowid = useSelector(state => state.search.rowid);
    const doApply = useSelector(state => state.search.doApply);
    const stickys = useSelector(state => state.env.stickys);
    const stickycolor = useSelector(state => state.env.stickycolor);
    const gridApi = useSelector(state => state.search.gridApi);
    const [show, setshow] = useState(false)

    const [selectcolor, setselectcolor] = useState("white");

    useEffect(() => {
        setshow(open);
        if (open) {
            if (stickycolor.length !== 0) setselectcolor(stickycolor[0]);
        }
    }, [open])

    useEffect(() => {
        if (!open) return;
        if (rowid === undefined) return;
        if (rowid.length > 1 && !isEmpty(gridApi)) {
            //選択行保持
            for (let i = 0; i < rowid.length; i++) {
                let rowNode = gridApi.getRowNode(rowid[i]);
                rowNode.setSelected(true);
            }
        }
    }, [rowid])

    //Stickey Mark
    function MarkApply(sticky) {
        let data = {
            key: datainfo.columnid,
            value: sticky,
            color: selectcolor,
            rowid: rowid,
            datainfo: datainfo
        };
        doApply(data, 0)
    }

    function onHandleClose() {
        fnc.current.searchlistclose();
    };

    function StickyList() {
        return <React.Fragment>
            <div style={{ marginRight: 10 }}>
                <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10 }}>
                    <span >付箋マーク</span>
                </div>
                <div style={{ textAlign: 'right', marginTop: 10 }} >
                    <Button variant="outlined" size="small" onClick={() => MarkApply('')}>マーククリア</Button>
                    <Button variant="outlined" size="small" onClick={onHandleClose}>中止</Button>
                </div>
            </div>
            <div style={{ padding: '0 10px', width: 600, marginBottom: 20, marginTop: 20 }}>
                {stickycolor.map(color => (
                    <IconButton value={color} size="small" onClick={() => setselectcolor(color)}>
                        <Icon style={{ color: color, fontSize: 25 }}>panorama_wide_angle_select</Icon>
                    </IconButton>
                ))}
            </div>
            <div style={{ padding: '0 10px', width: 600 }}>
                {stickys.map(sticky => (
                    <IconButton size="large" onClick={() => MarkApply(sticky)}>
                        <Icon style={{ color: selectcolor, fontSize: 30 }}>{sticky}</Icon>
                    </IconButton>
                ))}
            </div>
        </React.Fragment>
    }
    return (
        <div>
            <Drawer anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}>
                <StickyList />
            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
